<template>
    <div
        class="admin-row-actions admin-row-actions--inline"
        role="group"
        :aria-label="trans('general.actions')"
        @mouseover="onHover"
        @focusin="onHover"
        @mouseout="onLeave"
        @focusout="onLeave"
    >
        <slot></slot>
    </div>
</template>

<script>
let tipEl = null

function getTip() {
    if (!tipEl) {
        tipEl = document.createElement('div')
        tipEl.className = 'admin-row-actions-tooltip'
        tipEl.setAttribute('role', 'tooltip')
        document.body.appendChild(tipEl)
    }
    return tipEl
}

function hideTip() {
    if (!tipEl) {
        return
    }
    tipEl.classList.remove('is-visible')
}

export default {
    name: 'TableRowActionDropdown',
    mounted() {
        this.decorateActions()
    },
    updated() {
        this.$nextTick(() => this.decorateActions())
    },
    beforeDestroy() {
        hideTip()
    },
    methods: {
        actionTarget(event) {
            const root = event && event.target && event.target.closest
                ? event.target.closest('.dropdown-item, a, button')
                : null
            if (!root || !this.$el.contains(root)) {
                return null
            }
            return root
        },
        decorateActions() {
            if (!this.$el) {
                return
            }
            this.$el.querySelectorAll('a.dropdown-item, button.dropdown-item').forEach((el) => {
                const text = (el.textContent || '').replace(/\s+/g, ' ').trim()
                if (!text) {
                    return
                }
                el.setAttribute('aria-label', text)
                el.setAttribute('data-tooltip', text)
                el.classList.add('admin-row-actions__icon-btn')
            })
        },
        onHover(event) {
            const el = this.actionTarget(event)
            if (!el) {
                return
            }
            const text = el.getAttribute('data-tooltip') || (el.textContent || '').replace(/\s+/g, ' ').trim()
            if (!text) {
                return
            }
            const tip = getTip()
            const rect = el.getBoundingClientRect()
            tip.textContent = text
            tip.classList.add('is-visible')
            const tipWidth = tip.offsetWidth
            const left = Math.min(
                Math.max(8, rect.left + rect.width / 2 - tipWidth / 2),
                window.innerWidth - tipWidth - 8
            )
            tip.style.left = `${Math.round(left)}px`
            tip.style.top = `${Math.round(rect.top - 8)}px`
        },
        onLeave(event) {
            const next = event.relatedTarget
            if (next && this.$el.contains(next)) {
                return
            }
            hideTip()
        },
    },
}
</script>
